

export default {
    SET_PROVINSI_LIST(state, payload) {
        state.provinsiList = payload
    },
    SET_KABKOT_LIST(state, payload) {
        state.kabupatenKotaList = payload
    },
    SET_KECAMATAN_LIST(state, payload) {
        state.kecamatanList = payload
    },
    SET_KECAMATAN_TOTAL(state, payload) {
        state.totalKec = payload
    },
    SET_KABKOT_TOTAL(state, payload) {
        state.totalKabKot = payload
    },
    SET_PROVINSI_TOTAL(state, payload) {
        state.totalProv = payload
    }
}
